<template>
  <div>
    <onboarding-home :view="view.onboarding_data[0]" :translation="view.translation"/>

    <onboarding-home :view="view.onboarding_data[1]" :translation="view.translation"/>

    <onboarding-home :view="view.onboarding_data[2]" :translation="view.translation"/>
  </div>
</template>

<script>
export default {
  name: "ba-nation",
  props: ["view"],
  data() {
    return {
      t: null
    }
  }
}
</script>

<style scoped lang="scss">

</style>



// WEBPACK FOOTER //
// resources/office/js/components/ba-nation/index.vue